import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from 'react-leaflet';
import { getCookie } from 'typescript-cookie';
import KyLokal from '../../changeLang/drawLocalesKy';
import RuLokal from '../../changeLang/drawLocalesRu';
import styles from "./styles_map.module.css";

interface IContentPart {
  latitude: number;
  longitude: number;
}

const markers = [
  {
    latitude: 42.875969,
    longitude: 74.603701,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Чуйская область</h3>
      <p style="margin: 4px 0;">
        <strong>Молоко:</strong> 462 тыс/тонн<br />
        <strong>Шерсть:</strong> 1809 тыс/тонн<br />
        <strong>Яйца:</strong> 455 тыс/штук<br />
        <strong>Мясо:</strong> 57 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 40.315997,
    longitude: 73.439965,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ошская область</h3>
      <p style="margin: 4px 0;">
        <strong>Молоко:</strong> 347 тыс/тонн<br />
        <strong>Шерсть:</strong> 2220 тыс/тонн<br />
        <strong>Яйца:</strong> 69 тыс/штук<br />
        <strong>Мясо:</strong> 51 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 41.428298,
    longitude: 75.997628,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Нарынская область</h3>
      <p style="margin: 4px 0;">
        <strong>Молоко:</strong> 141 тыс/тонн<br />
        <strong>Шерсть:</strong> 2408 тыс/тонн<br />
        <strong>Яйца:</strong> 8.2 тыс/штук<br />
        <strong>Мясо:</strong> 33.7 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 42.491147,
    longitude: 78.399567,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ысык-Кульская область</h3>
      <p style="margin: 4px 0;">
        <strong>Молоко:</strong> 270 тыс/тонн<br />
        <strong>Шерсть:</strong> 1949 тыс/тонн<br />
        <strong>Яйца:</strong> 29.4 тыс/штук<br />
        <strong>Мясо:</strong> 37.5 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 40.060518,
    longitude: 70.819629,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Баткенская область</h3>
      <p style="margin: 4px 0;">
          <strong>Молоко:</strong> 101 тыс/тонн<br />
        <strong>Шерсть:</strong> 602 тыс/тонн<br />
        <strong>Яйца:</strong> 21 тыс/штук<br />
        <strong>Мясо:</strong> 17 тонн<br />
      </p>
      </div>
    `
  },
  {
    latitude: 41.802703,
    longitude: 71.958225,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Джалал-Абадская область</h3>
      <p style="margin: 4px 0;">
        <strong>Молоко:</strong> 372.9 тыс/тонн<br />
        <strong>Шерсть:</strong> 2396 тыс/тонн<br />
        <strong>Яйца:</strong> 77.1 тыс/штук<br />
        <strong>Мясо:</strong> 16.5 тонн<br />
      </p>
      </div>
    `
  }, {
    latitude: 42.520755,
    longitude: 72.250591,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Таласская область</h3>
      <p style="margin: 4px 0;">
        <strong>Молоко:</strong> 77 тыс/тонн<br />
        <strong>Шерсть:</strong> 1500 тыс/тонн<br />
        <strong>Яйца:</strong> 23 тыс/штук<br />
        <strong>Мясо:</strong> 14 тонн<br />
      </p>
      </div>
    `
  }


];
const customMarkerIcon = L.icon({
  iconUrl: '/proiz.svg',
  iconSize: [35, 55],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const AnimalMap = (props: IContentPart,) => {
  (L as any).drawLocal = getCookie('i18next') === 'ky' ? KyLokal : RuLokal;



  const [geoData, setGeoData] = useState<any>(null);

  useEffect(() => {
    const fetchGeoData = async (file: string, setGeoData: React.Dispatch<React.SetStateAction<any>>, label: string) => {
      try {
        const response = await fetch(`/${file}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        } else {
          console.warn(`Данные geojson отсутствуют или неверный формат в ${label}:`, data);
        }
      } catch (error) {

      }
    };
    fetchGeoData('polygons/search.json', setGeoData, 'polygons/search.json');
  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  return (
    <MapContainer
      className={styles.map}
      center={[41.5089324, 74.724091]}
      zoom={6}
      minZoom={6}
      scrollWheelZoom={true}
      zoomControl={false}
    >
      <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      {geoData && <GeoJSON data={geoData} style={getStyle('blue')} onEachFeature={onEachFeature} />}

      {markers.map((marker, index) => (
        <Marker key={index} position={[marker.latitude, marker.longitude]} icon={customMarkerIcon}>
          <Popup>
            <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
          </Popup>
        </Marker>
      ))}
      {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />}

    </MapContainer>
  );
};
